import React, { Component } from 'react';
import { Modal } from 'prospect-path-base';

import NewProduct from './NewProduct';
import ShowExistingProducts from './ShowExistingProducts';
import EditExistingProduct from './EditExistingProduct';
import ProductSuccess from './ProductSuccess';

import { connect } from 'react-redux';

class ProductModal extends Component {
    constructor(props) {
        super(props);
        let hasInitialStepProp = !!props.initialStep; // !! converts to boolean
        this.state = {
            currentStep: hasInitialStepProp ? props.initialStep : 'NewProductIfNoProducts',
            initialStep: !hasInitialStepProp,
            product: null,
        };

        this.getStep = this.getStep.bind(this);
        this.setStep = this.setStep.bind(this);
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const teamProductIds = nextProps.teamProducts.map(product => product.id);
        const availableProducts = nextProps.vendorProducts.filter(product => !teamProductIds.includes(product.id));

        if (prevState.initialStep && availableProducts.length > 0) {
            return { currentStep: 'ShowExistingProducts' }
        }
        if (prevState.initialStep && availableProducts.length === 0) {
            return { currentStep: 'NewProductIfNoProducts' }
        }

        return null;
    }
    getStep(step) {
        switch (step) {
            case 'ShowExistingProducts':
                return <ShowExistingProducts
                  setStep={this.setStep}
                  closeProductModal={this.props.closeProductModal}
                />;
            case 'EditExistingProduct':
                return <EditExistingProduct
                  setStep={this.setStep}
                  closeProductModal={this.props.closeProductModal}
                  product={this.state.product}
                />;
            case 'NewProductIfHasProducts':
                return <NewProduct
                  setStep={this.setStep}
                  closeProductModal={this.props.closeProductModal}
                  teamId={this.getTeamId()}
                  showBack={true}
                />;
            case 'ProductSuccess':
                return ProductSuccess(this.setStep, this.props.closeProductModal);
            default:
                return <NewProduct
                  setStep={this.setStep}
                  closeProductModal={this.props.closeProductModal}
                  teamId={this.getTeamId()}
                  showBack={false}
                />;
        }
    }
    setStep(step, product = null) {
        this.setState({
            currentStep: step,
            initialStep: false,
            product,
        });
    }
    /**
     * If a team id is passed as a prop use that otherwise use the current team from the redux store
     * @returns {*|Window.currentTeamId|*}
     */
    getTeamId() {
        if (this.props.teamId) {
            return this.props.teamId;
        }

        return this.props.currentTeamId;
    }

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
            >
                {this.getStep(this.state.currentStep)}
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    vendorProducts: state.productManagement.vendorProducts,
    teamProducts: state.productManagement.products.all,
    currentTeamId: state.teams.currentTeam,
});

export default connect(mapStateToProps)(ProductModal);
